<template>
  <div id="TransitInfo" class="TransitInfo">
    <div class="file-table">
      <table>
        <tr>
          <td>轨迹描述</td>
          <td>轨迹状态</td>
          <td>预计时间</td>
          <td>实际时间</td>
        </tr>
        <tr v-for="(item,index) in list" :key="index">
          <td>{{ item.descriptionEn }}</td>
          <td><span class="blue">{{ item.statusWeb }}</span></td>
          <td>{{ item.estimatedDateStr }}</td>
          <td>{{ item.dateStr }}</td>
        </tr>
      </table>
    </div>
    <div class="list-item">
      <div class="title">订舱信息</div>
      <div class="lable-item">
        <div class="lable">船公司:</div>
        <span class="content">{{ data.bookingCompany }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">船名船次:</div>
        <span class="content">{{ data.flight }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">分提单号:</div>
        <span class="content">{{ data.hawb }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">主提单号:</div>
        <span class="content">{{ data.mawb }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetOrderTrack
} from '@/api/order.js'
export default {
  name: 'TransitInfo',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      list: []
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      this.data = data
      this.GetOrderTrack()
    },
    GetOrderTrack() {
      var req = {
        orderNo: this.data.orderNo
      }
      GetOrderTrack(req).then(res => {
        if (res.code === 200) {
          this.list = res.data.list
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
.TransitInfo {
  display: flex;
  flex-wrap: wrap;
  width: auto;
  padding: 8px 24px 8px 32px;
  background: #FFFFFF;

  .file-table {
    border: 1px solid rgba(221, 221, 221, 0.56);
    border-radius: 8px;
    width: 65%;

    table {
      width: 100%;
      border-collapse: collapse;
      text-align: left;
      padding: 0 8px;

      tr:nth-of-type(1) {
        td {
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #777777;
          background: rgba(221, 221, 221, 0.24);

        }
      }

      tr {
        height: 40px;

        td {
          padding-left: 8px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;

          .division-line {
            display: inline-block;
            height: 20px;
            width: 100%;
            border-right: 1px solid #DDDDDD;
          }

          .blue {
            color: #027FFC;
            cursor: pointer;
          }
        }
      }
    }
  }

  .list-item {
    width: 29%;
    height: 256px;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    padding: 0 16px;
    margin: 0 12px;
    text-align: left;
    border: 1px solid rgba(221, 221, 221, 0.56);

    .title {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      height: 42px;
      line-height: 42px;
    }

    .lable-item {
      display: flex;
      height: 32px;
      align-items: center;

      .lable {
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;
        width: 132px;
      }

      .content {
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #333333;
      }

      .content-cancel {
        color: #E95506;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
